module.exports = __webpack_public_path__ + "img/img6.3d5b2647.jpg";